import { styled } from '@linaria/react';
import { newCOLORS } from '../../styles/colors';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  min-width: 800px;
`;

const Text = styled.div<{ fontSize?: number; fontWeight?: number; active?: boolean; grayed?: boolean }>`
  color: ${(props: { active?: boolean; grayed?: boolean }) =>
    props.active ? newCOLORS.white : props.grayed ? newCOLORS.gray2 : newCOLORS.black2};
  font-family: Figtree;
  font-size: ${(props: { fontSize?: number }) => props.fontSize || 15}px;
  font-style: normal;
  font-weight: ${(props: { fontWeight?: number }) => props.fontWeight || 500};
  line-height: normal;
`;

export { PageContainer, Text };
